export default "/images/calendar.svg?0aa970cf2052f800fc7aecd31246f748";